import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    margin: 'auto',
    maxWidth: '908px',
    background: 'rgba(197, 206, 214, 0.29)',
    borderRadius: '40px',
    padding: theme.spacing(14, 12, 8),
    marginTop: theme.spacing(20),
    marginBottom: theme.spacing(20),
    img: {
      height: '96px',
      width: '96px',
    },
    [theme.breakpoints.down('md')]: {
      img: {
        height: '76px',
        width: '76px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 5, 10),

      img: {
        width: '56px',
        height: '83px',
      },
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '48px',
    textTransform: 'uppercase',
    color: '#000000',
    padding: '0',
    textAlign: 'center',
    margin: theme.spacing(0, 0, 1),
    [theme.breakpoints.down('md')]: {
      fontSize: '32px',
      lineHeight: '44px',
    },
  },
  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
    textAlign: 'center',
    margin: theme.spacing(2, 0, 10),

    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '17px',
    },
  },
  brandInfo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  btnContainer: {
    width: '100%',

    display: 'flex',
    padding: theme.spacing(6, 0, 0),

    justifyContent: 'end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'start',
    },
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'start',
    },
  },
  recommendBtn: {
    width: '100%',
    background: 'black',
    color: 'white',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
  wrapperClass: {
    width: '100%',
  },
}))

export default useStyles
